<template>
  <div id="app" class="has-data">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { SentryCapture } from '@zz-common/sentry'
export default {
  // 不加这个的话错误容易被吞掉
  errorCaptured(err, vm, info) {
    console.log('err ============>', info, err)
    SentryCapture(`全局异常监控：${err} 其他信息：${info}`, 'error')
  }
}
</script>

<style>
@import '@zz/sasscore/reset.scss';
</style>
